import {
    AI_NOTE_STREAM_DONE,
    AI_NOTE_STREAM_ERROR,
    GENERATE_AI_SESSION_NOTE,
    RESET_AI_SESSION_NOTE,
} from './aiNote.type';

/**
 * Kicks off AI Summary generation for an appointment's session note.
 * Streamed chunks arrive separately via Socket.IO events
 * `ai:chunk` / `ai:done` / `ai:error` — see `useAiSessionNoteStream`.
 *
 * @param {string} apptId
 * @param {string} [formId] form-builder template id — lets the backend apply
 *   the form-author's custom AI-summary prompt. Omitting it uses the default.
 */
export const generateAiSessionNote = (apptId, formId) => ({
    type: GENERATE_AI_SESSION_NOTE,
    payload: { apptId, formId },
});

export const resetAiSessionNote = () => ({
    type: RESET_AI_SESSION_NOTE,
});

/** Streaming reached `ai:done` — flips `streamStatus` to `'done'`. */
export const markAiNoteStreamDone = () => ({
    type: AI_NOTE_STREAM_DONE,
});

/** Streaming hit `ai:error` — flips `streamStatus` to `'error'`. */
export const markAiNoteStreamError = () => ({
    type: AI_NOTE_STREAM_ERROR,
});
